<div class="style-sheet-sprite" style="position: relative; width: 100%; height: 100%; isolation: isolate">
  @let _sprite = sprite();
  @if (_sprite) {
    <div
      style="position: absolute; pointer-events: none; z-index: -1"
      [style]="{
        top: _sprite.scale * -_sprite.paddingBox.from[1] + 'px',
        right: _sprite.scale * -(_sprite.size[0] - _sprite.paddingBox.to[0]) + 'px',
        bottom: _sprite.scale * -(_sprite.size[1] - _sprite.paddingBox.to[1]) + 'px',
        left: _sprite.scale * -_sprite.paddingBox.from[0] + 'px',
      }"
    >
      <app-nine-sliced-sprite
        [src]="_sprite.url"
        [x]="[_sprite.contentBox.from[0] / _sprite.size[0], _sprite.contentBox.to[0] / _sprite.size[0]]"
        [y]="[_sprite.contentBox.from[1] / _sprite.size[1], _sprite.contentBox.to[1] / _sprite.size[1]]"
        [width]="
          (borders().includes('TOP') ? _sprite.scale * _sprite.contentBox.from[1] : 0) +
          'px ' +
          (borders().includes('RIGHT') ? _sprite.scale * (_sprite.size[0] - 1 - _sprite.contentBox.to[0]) : 0) +
          'px ' +
          (borders().includes('BOTTOM') ? _sprite.scale * (_sprite.size[1] - 1 - _sprite.contentBox.to[1]) : 0) +
          'px ' +
          (borders().includes('LEFT') ? _sprite.scale * _sprite.contentBox.from[0] : 0) +
          'px'
        "
        style="position: absolute; inset: 0"
      />
    </div>
    <div
      style="width: 100%; height: 100%"
      [style]="{
        paddingTop: _sprite.scale * (_sprite.contentBox.from[1] - _sprite.paddingBox.from[1]) + 'px',
        paddingLeft: _sprite.scale * (_sprite.contentBox.from[0] - _sprite.paddingBox.from[0]) + 'px',
        paddingRight: _sprite.scale * (_sprite.paddingBox.to[0] - _sprite.contentBox.to[0]) + 'px',
        paddingBottom: _sprite.scale * (_sprite.paddingBox.to[1] - _sprite.contentBox.to[1]) + 'px',
        color: text()?.color,
        fontWeight: text()?.bold ? 'bold' : 'normal',
      }"
    >
      <ng-content></ng-content>
    </div>
  }
</div>
